export const EVENT_TYPES = {
  brake: { label: "Harsh Braking", color: "#EAB308" },
  cornering_left: { label: "Cornering Left", color: "#B91C1C" },
  cornering_right: { label: "Cornering Right", color: "#C2410C" },
  harsh_acceleration: { label: "Harsh Acceleration", color: "#0EA5E9" }
};

// raw CSV labels -> event type keys
export const EVENT_TYPE_ALIASES = {
  "harsh braking": "brake",
  braking: "brake",
  brake: "brake",
  "left cornering": "cornering_left",
  "cornering left": "cornering_left",
  "right cornering": "cornering_right",
  "cornering right": "cornering_right",
  "harsh acceleration": "harsh_acceleration",
  acceleration: "harsh_acceleration"
};

export const UNKNOWN_EVENT_COLOR = "#71717A";

// max distance (m) between an event and a road for the event to snap to it
export const SNAP_TOLERANCE_M = 30;
// max difference (deg) between the event heading and the road bearing
export const HEADING_TOLERANCE_DEG = 60;
// For cornering events the heading is captured mid/after the turn, so the road the vehicle
// travelled lies on the turn's inside: up to CORNERING_APPROACH_TOLERANCE_DEG clockwise of the
// heading for a left turn (counter-clockwise for a right turn), with a little slack the other way.
export const CORNERING_APPROACH_TOLERANCE_DEG = 90;
export const CORNERING_SLACK_DEG = 15;
// head follows the recorded heading unless it is within this of the road bearing (GPS jitter)
export const HEAD_SNAP_TOLERANCE_DEG = 10;
// when the head diverges from the road, this much of the arrow (fraction of its length,
// clamped to [MIN_BLEND_M, MAX_BLEND_M] metres) is curved from the road into the heading
export const BLEND_FRACTION = 0.5;
export const MIN_BLEND_M = 6;
export const MAX_BLEND_M = 25;
// max bearing change (deg) tolerated when continuing an arrow onto a connected way
export const CONTINUATION_TOLERANCE_DEG = 60;
export const MAX_WAY_HOPS = 10;

export const MIN_ARROW_LENGTH_M = 20;
export const MAX_ARROW_LENGTH_M = 120;

export const MPH_TO_MPS = 0.44704;
